import PropTypes from 'prop-types';
import styles from './FJTabGeneratingNumber.module.less';

function FJTabGeneratingNumber({ isShow, generatingNum }) {
    if (!isShow) return null;
    return <div className={styles.container}>{generatingNum}</div>;
}

FJTabGeneratingNumber.propTypes = {
    isShow: PropTypes.bool,
    generatingNum: PropTypes.number,
};

export default FJTabGeneratingNumber;
